import { actions } from './paymentType/actions'
import { getters } from './paymentType/getters'
import { state } from './paymentType/state'
import { mutations } from './paymentType/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
